/**
 * Created by mh on 17/12/12
 */
Date.prototype.Format = function (fmt) { // author: meizz
	var o = {
		"M+": this.getMonth() + 1, // 月份
		"d+": this.getDate(), // 日
		"h+": this.getHours(), // 小时
		"m+": this.getMinutes(), // 分
		"s+": this.getSeconds(), // 秒
		"q+": Math.floor((this.getMonth() + 3) / 3), // 季度
		"S": this.getMilliseconds() // 毫秒
	};
	if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
	}
	return fmt;
};

export const addDay = function (date, days) {
	var d = new Date(date);
	d.setDate(d.getDate() + days);
	return d;
}

export const os = (function () {
	var ua = window.navigator.userAgent,
		isWindowsPhone = /(?:Windows Phone)/.test(ua),
		isWeixin = /(?:MicroMessenger)/.test(ua),
		isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
		isAndroid = /(?:Android)/.test(ua),
		isFireFox = /(?:Firefox)/.test(ua),
		isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua)),
		isiPhone = /(?:iPhone)/.test(ua) && !isTablet,
		isIos = /(?:iPhone|iPad|iPod)/.test(ua),
		isPc = !isiPhone && !isAndroid && !isSymbian && !isTablet;

	return {
		isTablet: isTablet,
		isWeixin: isWeixin,
		isiPhone: isiPhone,
		isAndroid: isAndroid,
		isIos: isIos,
		isPc: isPc
	}
})();

export function setHtmlFontSize() {
	window.rem = (document.documentElement.clientWidth || window.innerWidth) / 10;
	document.documentElement.style.fontSize = window.rem + 'px';

	var realFz = +getComputedStyle(document.documentElement).fontSize.replace("px", "");
	if (window.rem !== realFz) {
		window.rem = window.rem * (window.rem / realFz);
		document.documentElement.style.fontSize = window.rem + 'px';
	}
	// console.log(getComputedStyle(document.documentElement).fontSize);
};

// set cookie
export function setCookie(name, value) {
	var Days = 30;
	var exp = new Date();
	exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000);
	document.cookie = name + "=" + escape(value) + ";path=/;expires=" + exp.toGMTString();
	return value;
};
// get cookie
export function getCookie(name) {
	// console.log(document.cookie);
	var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	var arr = document.cookie.match(reg);
	if (arr) {
		return unescape(arr[2]);
	} else {
		return null;
	}
};
// remove cookie
export function removeCookie(name) {
	var exp = new Date();
	exp.setTime(exp.getTime() - 1000);
	var cval = getCookie(name);
	if (cval != null) {
		document.cookie = name + "=" + cval + ";path=/;expires=" + exp.toGMTString();
	}
};
// set localStorage
export function setLocalStorage(name, value) {
	localStorage.setItem(name, value);
	return value;
}
// get localStorage
export function getLocalStorage(name) {
	return localStorage.getItem(name);
}
// remove localStorage
export function removeLocalStorage(name) {
	localStorage.removeItem(name);
}

// set localStorage
export function setSessionStorage(name, value) {
	sessionStorage.setItem(name, value);
	return value;
}
// get localStorage
export function getSessionStorage(name) {
	return sessionStorage.getItem(name);
}
// remove localStorage
export function removeSessionStorage(name) {
	sessionStorage.removeItem(name);
}

// 补零
export function pad(num, n) {
	var len = num.toString().length;
	while (len < n) {
		num = "0" + num;
		len++;
	}
	return num;
};
// 心率区间百分比
export function getZonePercent(rate, age) {
	return rate / (220 - age) * 100;
};
// 心率区间
export function getZone(percent) {
	if (percent >= 90) {
		return 'Z5';
	} else if (percent >= 80) {
		return 'Z4';
	} else if (percent >= 70) {
		return 'Z3';
	} else if (percent >= 60) {
		return 'Z2';
	} else if (percent >= 50) {
		return 'Z1';
	} else {
		return 'Z0';
	}
};
// 处理图表数据
export function dealChartData(data) {
	if (data >= 50) {
		return data;
	} else {
		return 40 + 10 * data / 50;
	}
};
// 年龄
export function getAge(birthday) {
	if (!birthday) {
		return 23;
	}
	let birthdayStrArr = birthday.replace(/\//g, '-').split('-'),
		birthYear = birthdayStrArr[0],
		birthMonth = birthdayStrArr[1],
		birthDate = birthdayStrArr[2];
	let now = new Date(),
		nowYear = now.getFullYear(),
		nowMonth = now.getMonth() + 1,
		nowDate = now.getDate();
	let age = 0;
	if (birthYear !== nowYear) {
		age = nowYear - birthYear;
		if (age > 0) {
			if (nowMonth === birthMonth) {
				if (nowDate < birthDate) {
					age--;
				}
			} else if (nowMonth < birthMonth) {
				age--;
			}
		} else {
			age = -1;
		}
	}
	return age;
};
// cookie用户信息
export function getUserInfoFromCache() {
	var userStr = getLocalStorage('user');
	if (userStr && userStr !== 'null') {
		return JSON.parse(userStr);
	} else {
		return null;
	}
};

// debounce
export function debounce(func, delay) {
	let timer;
	return function (...args) {
		if (timer) {
			clearTimeout(timer);
		}
		timer = setTimeout(() => {
			func.apply(this, args);
		}, delay);
	}
};
// throttle
export function throttle(func, delay) {
	let last = 0;
	return function (...args) {
		let curr = +new Date();
		if (curr - last >= delay) {
			func.apply(this, args);
			last = curr;
		}
	}
};

// dom
export const on = (function () {
	if (document.addEventListener) {
		return function (element, event, handler) {
			if (element && event && handler) {
				element.addEventListener(event, handler, false);
			}
		};
	} else {
		return function (element, event, handler) {
			if (element && event && handler) {
				element.attachEvent('on' + event, handler);
			}
		}
	}
})();
export const off = (function () {
	if (document.removeEventListener) {
		return function (element, event, handler) {
			if (element && event && handler) {
				element.removeEventListener(event, handler, false);
			}
		}
	} else {
		return function (element, event, handler) {
			if (element && event && handler) {
				element.detachEvent('on' + event, handler);
			}
		}
	}
})();
export const once = function (element, event, handler) {
	var listener = function () {
		if (handler) {
			handler.apply(this, arguments);
		}
		off(element, event, listener);
	};
	on(element, event, listener);
};

// 懒加载
// export function asyncComponent(option) {
// 	let fn = (resolve) => {
// 		import('@/components/' + option.path).then((module) => {
// 			resolve(module);
// 		});
// 	};
// 	return fn;
// };

export function getCurrentTime() {
	var keep = '';
	var date = new Date();
	var y = date.getFullYear();
	var m = date.getMonth() + 1;
	m = m < 10 ? '0' + m : m;
	var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
	var h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
	var f = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
	var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
	var rand = Math.round(Math.random() * 899 + 100);
	keep = y + '' + m + '' + d + '' + h + '' + f + '' + s;
	return keep; //20160614134947
}

let $utils = {
	os,
	setHtmlFontSize,
	setCookie,
	getCookie,
	removeCookie,
	setLocalStorage,
	getLocalStorage,
	removeLocalStorage,
	pad,
	getZonePercent,
	getZone,
	dealChartData,
	getAge,
	getUserInfoFromCache,
	getCurrentTime
};

export default {
	install(Vue) {
		Vue.utils = $utils;
		Vue.prototype.$utils = $utils;
	}
};



// WEBPACK FOOTER //
// ./src/common/js/utils.js